import { MultiLangText } from "src/utils/types"
import { SubCaste } from "../../entities/subCaste"
import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	code: string
	name: MultiLangText
}

export async function subCasteAddApi(payload: RequestDataShape, token: string) {
	const endpoint = "/subCaste/add/v1"
	const requester = new ApiRequester<RequestDataShape, SubCaste>(endpoint)
	return await requester.sendRequest(payload, token)
}
